import Analytics from "analytics";
// import googleAnalyticsPlugin from "@analytics/google-analytics";
import segmentPlugin from '@analytics/segment';
import { history } from "./router.js";
import facebookPixelPlugin from './pixel'

// Initialize analytics and plugins
// Documentation: https://getanalytics.io
const analytics = Analytics({
  debug: process.env.NODE_ENV !== "production",
  environment: process.env.REACT_APP_ENVIRONMENT,
  plugins: [
    segmentPlugin({
      writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY
    }),
    facebookPixelPlugin({
      whatEver: "userConfig.whatEver",
      elseYouNeed: "userConfig.elseYouNeed"
    })
  ]
});

analytics.on('trackStart', ({ payload }) => {
  // console.log('payload', payload)
  payload.properties.environment = process.env.REACT_APP_ENVIRONMENT;
  payload.properties.location = "web";
})


// Track initial pageview
// if (typeof window !== "undefined") {
//   analytics.page();
// }

// Track pageview on route change
history.listen(() => {
  analytics.page();
});

export default analytics;

